import { FilterList, MultiSelectSimpleFilter, Sort } from "@dash/filters";

import { SignalLevel, signalLevels, SignalSubjectDocType } from "@megaron/docs-contracts";

import { isSignalsSortValue, SignalsFilterValues, SignalsSortField } from "./filterSignals";
import { signalAppLabel } from "./signalAppLabel";
import { signalLevelLabel } from "./signalLevel";
import { signalSubjectDocTypeOptions } from "./signalSubjectDocTypeLabel";

const levelOptions = signalLevels.map((level) => ({
  label: signalLevelLabel[level],
  value: level,
}));

const sortOptions: { label: string; value: SignalsSortField }[] = [
  { label: "Data", value: "createdAt" },
  { label: "Nazwa", value: "name" },
  { label: "Poziom", value: "level" },
  { label: "Aplikacja", value: "app" },
];

type Props = {
  values: SignalsFilterValues;
  appOptions: { label: string; value: string }[];
  signalTypeOptions: { label: string; value: string }[];
  onChange: (patch: Partial<SignalsFilterValues>) => void;
};

export const AllSignalsFilters: React.FC<Props> = ({ values, appOptions, signalTypeOptions, onChange }) => (
  <FilterList>
    <MultiSelectSimpleFilter
      label="Aplikacja"
      values={values.apps}
      options={appOptions}
      onChange={(apps) => onChange({ apps })}
    />
    <MultiSelectSimpleFilter
      label="Typ sygnału"
      values={values.signalTypes}
      options={signalTypeOptions}
      onChange={(signalTypes) => onChange({ signalTypes })}
    />
    <MultiSelectSimpleFilter<SignalSubjectDocType>
      label="Typ dokumentu"
      values={values.subjectDocTypes}
      options={signalSubjectDocTypeOptions}
      onChange={(subjectDocTypes) => onChange({ subjectDocTypes })}
    />
    <MultiSelectSimpleFilter<SignalLevel>
      label="Poziom"
      values={values.levels}
      options={levelOptions}
      onChange={(levels) => onChange({ levels })}
    />
    <Sort
      type="button"
      label="Sortuj"
      value={{ field: values.sort?.field ?? "", order: values.sort?.order ?? "" }}
      options={sortOptions}
      onChange={(value) => onChange({ sort: isSignalsSortValue(value) ? value : undefined })}
    />
  </FilterList>
);

export const appOptionsFromSignals = (apps: string[]) =>
  apps.map((app) => ({
    label: signalAppLabel(app),
    value: app,
  }));

export const signalTypeOptionsFromSignals = (
  signalTypes: string[],
  signalTypeLabel: (signalType: string) => string,
) =>
  signalTypes.map((signalType) => ({
    label: signalTypeLabel(signalType),
    value: signalType,
  }));
